import React, { FC, useContext } from 'react';
import { AddEntityWatcherButton } from '../../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import { LawyerActions } from './LawyerActions';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { LawyerContext } from '../LawyerContext';

type Props = {
  isVisible: boolean;
};

export const LawyerActionSlider: FC<Props> = ({ isVisible }) => {
  const source = 'lawyer_page';
  const { openRestrictedModal } = useRestrictedModal();
  const {
    lawyerInfos: { lawyerId },
    lawyerName,
  } = useContext(LawyerContext);

  return (
    <div className="sub-header__rails__tunnel">
      <div className="sub-header__rails__mask" />
      <div
        className={
          isVisible
            ? 'sub-header__rails__slider'
            : 'sub-header__rails__slider__move'
        }
      >
        <div className="add-entity-watcher__page-slider">
          <AddEntityWatcherButton
            queryParams={{ lid: lawyerId, q: lawyerName }}
            uniqueId={lawyerId}
            restrict={() =>
              openRestrictedModal({ source: 'want_to_follow_lawyer' })
            }
            source={source}
          />
        </div>

        <LawyerActions source={source} />
      </div>
    </div>
  );
};
